<template>
  <ui-report-panel class="overflow-hidden" title="Completed Packages" :filters="filters" :fetch="fetch" @filtersChanged="({ refresh }) => refresh()" v-slot="{ report }">
    <ui-table v-if="report && report.length > 0" :headers="['Package', 'Client', 'Status']" v-slot="{ cellClass }">
      <tr v-for="item in report" :key="item.id" class="hover:bg-blue-50 cursor-pointer" @click="goTo(item._links.frontend.view)">
        <td :class="cellClass" class="font-medium text-gray-900" :title="item.common_title">
          {{ truncate(item.common_title, 50) }}
        </td>
        <td :class="cellClass" :title="item.client.name">
          {{ truncate(item.client.name, 50) }}
        </td>
        <td :class="cellClass">
          {{ item.status.name }}
        </td>
      </tr>
    </ui-table>
    <div v-else class="px-4 py-16 text-center text-gray-400">
      There has been no completed packages within the provided filters...
    </div>
  </ui-report-panel>
</template>

<script>
import { Statistic } from '@models'
import { truncate } from '@utils'

export default {
    props: {
        filters: Object,
    },
    methods: {
        async fetch (filters) {
            return Statistic.getDetailed('completed_packages', filters.from, filters.to)
        },
        goTo (url) {
            window.location = url
        },
        truncate,
    },
}
</script>
